module.exports = __webpack_public_path__ + "static/media/Gith.218005a0.png";